"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualificationsOfPartner = void 0;
const typeorm_1 = require("typeorm/browser");
let QualificationsOfPartner = class QualificationsOfPartner {
};
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], QualificationsOfPartner.prototype, "partnerId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "hwoA", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "hwoB1", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "hwoB2", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'kein_hwo',
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "noHwo", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'weiterbildung',
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "additionalEducation", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'zusatzqualifikation',
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "additionalQualification", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'transporter',
    }),
    __metadata("design:type", Array)
], QualificationsOfPartner.prototype, "transporter", void 0);
QualificationsOfPartner = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: `
    SELECT
      p.id partner_id,
      COALESCE(array_remove(string_to_array(hwo_a__c,';'),'keine'),ARRAY[]::TEXT[]) hwo_a,
      COALESCE(array_remove(string_to_array(hwo_b__c,';'),'keine'),ARRAY[]::TEXT[]) hwo_b1,
      COALESCE(array_remove(string_to_array(hwo_b2__c,';'),'keine'),ARRAY[]::TEXT[]) hwo_b2,
      COALESCE(array_remove(string_to_array(nicht_hwo__c	,';'),'keine'),ARRAY[]::TEXT[]) kein_hwo,
      COALESCE(array_remove(string_to_array(weiterbildung__c,';'),'keine'),ARRAY[]::TEXT[]) weiterbildung,
      COALESCE(array_remove(string_to_array(zusatzqualifikation__c,';'),'keine'),ARRAY[]::TEXT[]) zusatzqualifikation,
      (CASE
        WHEN ARRAY['LKW'] <@ transporter_raw THEN ARRAY['PKW', 'Anhänger', 'Transporter', '3,5 Tonner', 'LKW']
        WHEN ARRAY['3,5 Tonner'] <@ transporter_raw THEN ARRAY['PKW', 'Anhänger', 'Transporter', '3,5 Tonner']
        WHEN ARRAY['Transporter'] <@ transporter_raw THEN ARRAY['PKW', 'Anhänger', 'Transporter']
        WHEN ARRAY['Anhänger'] <@ transporter_raw THEN ARRAY['PKW', 'Anhänger']
        ELSE transporter_raw
      END) transporter
    FROM
      public.account p,
      COALESCE(array_remove(string_to_array(p.transporter__c,';'),'Kein'),ARRAY[]::TEXT[]) transporter_raw
    WHERE
      role = 'partner'
  `,
        name: 'qualifications_of_partner',
        schema: 'public',
    })
], QualificationsOfPartner);
exports.QualificationsOfPartner = QualificationsOfPartner;
//# sourceMappingURL=qualifications-of-partners.js.map